import React, {Component, useEffect, useState} from 'react';
import { Col, Row, Typography, Button, Spin, Space, Input, Empty, Table, Skeleton, Popover, Modal, Form, Radio, Checkbox, Divider, Select, Slider, Tooltip, Popconfirm, Switch } from 'antd';
import Box from '../../components/utility/box';
import { DvAxiosRequestEx, DvIntlMessages,DvNotification } from '../../components/utility/dvGeneralUtilities';
import moment from 'moment';
import { DISPLAY_DATE_TIME_FORMAT } from '../../helpers/utility';
import { InfoCircleOutlined } from '@ant-design/icons';
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import styled from "styled-components";
import ReactJson from 'react-json-view'
import { connect } from 'react-redux';

const MarkdownStyle = styled.div`
th { 
  padding-left:4px;
  padding-right:4px;
}
td {
    padding-left:4px;
    padding-right:4px;
}
`;


function AiClinician(props) {
  const availableModels = [
    {id:'gemini-2.5-pro', maxOutputTokens:65000}, 
    {id:'gemini-2.5-flash', maxOutputTokens:65000},
    {id:'gemini-2.5-flash-lite', maxOutputTokens:65000}, 
    {id:'gemini-2.0-flash', maxOutputTokens:8100}, 
    {id:'gemini-2.0-flash-lite', maxOutputTokens:8100},
    {id:'gemini-3-flash-preview', maxOutputTokens:65000}
    
  ];
  const availableRegions = ['europe-west1'];
  const [patientId, setPatientId] = useState(undefined);
  const [isFetchingPatient, setIsFetchingPatient] = useState(false);
  const [isFetchingPatientJson, setIsFetchingPatientJson] = useState(false);
  const [isFetchingPatientFiles, setIsFetchingPatientFiles] = useState(false);
  const [isFetchingPatientEPrescriptionMedications, setIsFetchingPatientEPrescriptionMedications] = useState(false);
  const [isFetchingPatientEmnnData, setIsFetchingPatientEmnnData] = useState(false);
  const [isSavingNewPrompt, setIsSavingNewPrompt] = useState(false);
  const [llmModel, setLlmModel] = useState(availableModels[0])
  const [llmRegion, setLlmRegion] = useState(availableRegions[0]);
  const [temperature, setTemperature] = useState(0);
  const [topP, setTopP] = useState(0);
  const [maxOutputTokens, setMaxOutputTokens] = useState(availableModels[0].maxOutputTokens);

  const [isFetchingPromptTypeNames, setIsFetchingPromptTypeNames] = useState(false);
  const [isPromptTypeNamesPopoverOpen, setIsPromptTypeNamesPopoverOpen] = useState(false);
  const [isFetchingPromptType, setIsFetchingPromptType] = useState(false);
  const [isLoadingAiChats, setIsLoadingAiChats] = useState(false);
  const [newPromptTypeName, setNewPromptTypeName] = useState(undefined);

  const [promptTypeNames, setPromptTypeNames] = useState([]);
  const [promptType, setPromptType] = useState(undefined);
  const [patientMainData, setPatientMainData] = useState(undefined);
  const [patientJson, setPatientJson] = useState(undefined);
  const [selectedPatientJsonMode, setSelectedPatientJsonMode] = useState('json');
  const [patientFiles, setPatientFiles] = useState(undefined);
  const [patientEPrescriptionMedications, setPatientEPrescriptionMedications] = useState(undefined);
  const [selectedEPrescriptionMedicationsMode, setSelectedEPrescriptionMedicationsMode] = useState('json');
  const [patientEmnnData, setPatientEmnnData] = useState(undefined);
  const [selectedPatientEmnnDataMode, setSelectedPatientEmnnDataMode] = useState('json');
  const [selectedPatientFiles, setSelectedPatientFiles] = useState(undefined);

  const [aiChats, setAiChats] = useState([]);
  const [selectedAiChat, setSelectedAiChat] = useState(undefined);
  const [selectedAiChatLlmConfigurationMode, setSelectedAiChatLlmConfigurationMode] = useState('json');
  const [selectedAiChatResponseMarkdownMode, setSelectedAiChatResponseMarkdownMode] = useState('markdown');


  useEffect(()=> {
    if (!props.webSocketConnection || !props.currentUser || !patientId) return;
    const callback = (aiChatPatientId) => aiChatsUpdatedCallback(Number(patientId), aiChatPatientId);
    const channel = props.webSocketConnection.private(`patient-${patientId}`).listen(".aiClinicianChat.updated", ({aiChatId, processingStatus, patientId:aiChatPatientId})=>{
      callback(Number(aiChatPatientId));
    });

    return () => {
      channel.stopListening(".aiClinicianChat.updated");
    };
  }, [props.webSocketConnection, props.currentUser, patientId]);

  const aiChatsUpdatedCallback = (selectedPatientId, patientIdOfUpdatedChats) => {
    if (selectedPatientId === patientIdOfUpdatedChats) fetchAiChats();
  }

  useEffect(()=> {
    setIsFetchingPromptTypeNames(true);
    DvAxiosRequestEx({
      url: `/ehrAdmin/prompt-types`,
      method: 'GET'
    }).then((response)=> {
      setIsFetchingPromptTypeNames(false);
      setPromptTypeNames(response.data);
    }, () => setIsFetchingPromptTypeNames(false));
  }, []);

  useEffect(()=> {
    setPatientMainData(undefined);
    setAiChats([]);
  }, [patientId]);

  useEffect(()=> {
    setPatientJson(undefined);
    setPromptType(undefined);
    setPatientFiles(undefined);
    setSelectedPatientFiles(undefined);
    setPatientEPrescriptionMedications(undefined);
    setPatientEmnnData(undefined);
    if (!newPromptTypeName) return;

    setIsFetchingPromptType(true);
    DvAxiosRequestEx({
      url: `/ehrAdmin/prompt-types/${encodeURIComponent(newPromptTypeName)}`,
      method: 'GET'
    }).then((response)=> {
      setIsFetchingPromptType(false);
      setPromptType(response.data.prompt);
    }, () => setIsFetchingPromptType(false));

    setIsFetchingPatientJson(true);
    DvAxiosRequestEx({
      url: `/ehrAdmin/patients/${patientId}/json`,
      method: 'GET'
    }).then((response)=> {
      setIsFetchingPatientJson(false);
      setPatientJson(response.data);
    }, () => setIsFetchingPatientJson(false));

    setIsFetchingPatientFiles(true);
    DvAxiosRequestEx({
      url: `/ehrAdmin/patients/${patientId}/files`,
      method: 'GET'
    }).then((response)=> {
      setIsFetchingPatientFiles(false);
      setPatientFiles(response.data);
      setSelectedPatientFiles(response.data.filter(pf => pf.file_extension === "pdf" || pf.file_extension === "PDF"));
    }, () => setIsFetchingPatientFiles(false));

    setIsFetchingPatientEPrescriptionMedications(true);
    DvAxiosRequestEx({
      url: `/ehrAdmin/patients/${patientId}/e-prescription-medications`,
      method: 'GET'
    }).then((response)=> {
      setIsFetchingPatientEPrescriptionMedications(false);
      setPatientEPrescriptionMedications(response.data);
    }, () => setIsFetchingPatientEPrescriptionMedications(false));

    setIsFetchingPatientEmnnData(true);
    DvAxiosRequestEx({
      url: `/ehrAdmin/patients/${patientId}/emnn`,
      method: 'GET'
    }).then((response)=> {
      setIsFetchingPatientEmnnData(false);
      setPatientEmnnData(response.data);
    }, () => setIsFetchingPatientEmnnData(false));

  }, [newPromptTypeName]);


  const fetchPatient = () => {
    setIsFetchingPatient(true);
    setPatientMainData(undefined);
    setAiChats([]);
    DvAxiosRequestEx({
      url: `/ehrAdmin/patients/${patientId}`,
      method: 'GET'
    }).then(response1=> {
      setIsFetchingPatient(false);
      setPatientMainData(response1.data);
      fetchAiChats();
    }, (error1)=> {
      setIsFetchingPatient(false);
    });
  }

  const fetchAiChats = ()=> {
    setSelectedAiChat(undefined);
    setIsLoadingAiChats(true);
      DvAxiosRequestEx({
        url: `/ehrAdmin/patients/${patientId}/ai-chats`,
        method: 'GET'
      }).then(response2 => {
        setIsLoadingAiChats(false);
        setAiChats(response2.data);
      }, (error2) => {
        setIsLoadingAiChats(false);
      });
  }

  const getCreatedDateWithDuration = (aiChat) => {
    if (!aiChat.updated_at) return moment(aiChat.created_at).format(DISPLAY_DATE_TIME_FORMAT);
    if (aiChat.updated_at === aiChat.created_at) return moment(aiChat.created_at).format(DISPLAY_DATE_TIME_FORMAT);
    return moment(aiChat.created_at).format(DISPLAY_DATE_TIME_FORMAT) + " (" + moment(aiChat.updated_at).diff(moment(aiChat.created_at), 'seconds') +" sec)";
  }


  return (
    <>
      <Typography.Title level={3}>{DvIntlMessages('general.aiClinician')}</Typography.Title>
      <Box>
        <Form>
          <Space direction='horizontal'>
            <Input value={patientId} placeholder='Type patient id (number)' onChange={(e)=>setPatientId(e.target.value)}/>
            <Button type='primary' htmlType='submit' loading={isFetchingPatient} disabled={!patientId || isNaN(patientId)} onClick={()=>fetchPatient()}>Get patient</Button>
            {patientMainData && <Typography.Title style={{marginBottom:0}} level={3}>{patientMainData.last_name} {patientMainData.first_name} (from {patientMainData.clinic.title})</Typography.Title>}
          </Space>
        </Form>
        {patientMainData && <div style={{marginTop:10}}>
          <Space direction='horizontal'>
            <Typography.Title style={{marginBottom:0}} level={4}>Prompts</Typography.Title>
            {promptTypeNames.length > 0 && <Popover open={isPromptTypeNamesPopoverOpen} onOpenChange={(isOpen)=>setIsPromptTypeNamesPopoverOpen(isOpen)} trigger='click' content={<Space direction='vertical'>
              {promptTypeNames.map((pt,index)=><Button size='small' key={index} onClick={()=> {setNewPromptTypeName(pt); setIsPromptTypeNamesPopoverOpen(false);}}>{pt}</Button>)}
            </Space>}><Button type='primary' loading={isFetchingPromptTypeNames}>New prompt</Button></Popover>}
            <Button type='default' loading={isLoadingAiChats} onClick={()=>fetchAiChats()}>Refresh</Button>
          </Space>
        </div>}
        <div style={{marginTop:10}}>
          {(patientMainData && isLoadingAiChats) && <Skeleton loading={true}/>}
          {(patientMainData && !isLoadingAiChats && aiChats.length === 0) && <Empty/>}
          {(patientMainData && !isLoadingAiChats && aiChats.length > 0) && <Table 
            onRow={(rowData, rowIndex) => {
              return {
                onClick: event => {setSelectedAiChat(rowData)}, // click row
              };
            }}
           size='small' showHeader={true} dataSource={aiChats} columns={[
            {
              key:'created_at',
              dataIndex:'created_at',
              title:'Date (duration)',
              width:50,
              render:(value, record, index) => getCreatedDateWithDuration(record)
            },
            {
              key:'last_update_user',
              dataIndex:'last_update_user',
              title:'User',
              width:50,
              render:(value, record, index) => {
                return record.last_update_user.last_name + ' ' + record.last_update_user.first_name;
              }
            },
            {
              key:'prompt_type',
              dataIndex:'prompt_type',
              title:'Prompt type',
              width:70,
            },
            {
              key:'raw_prompt',
              dataIndex:'raw_prompt',
              title:'Prompt',
              width:300,
              render:(value, record, index) => {
                return <div style={{overflow:'auto', width:300, whiteSpace:'pre', maxHeight:200}}>{value}</div>;
              }
            },
            {
              key:'llm_configuration',
              dataIndex:'llm_configuration',
              title:'LLM configuration',
              width:100,
              render:(value, record, index) => {
                return <div style={{overflow:'auto', whiteSpace:'pre', width:100, maxHeight:200}}>{JSON.stringify(value, null, 5)}</div>;
              }
            },
            {
              key:'response',
              dataIndex:'response',
              title:'Response',
              render:(value, record, index) => {
                return <Spin spinning={record.processing_status !== 'completed'}>
                    <div style={{overflow:'auto', whiteSpace:'pre-wrap', maxHeight:200}}>
                      <ReactMarkdown children={value} remarkPlugins={[remarkGfm]} />
                    </div>
                  </Spin>;
              }
            },
            {
              key:'error',
              dataIndex:'error',
              title:'Error',
              width:100,
              render:(value, record, index) => {
                return <div style={{whiteSpace:'pre', overflow:'auto', width:100, maxHeight:200}}>{value}</div>;
              }
            }
          ]}/>}
        </div>
      </Box>

      <Modal 
        closable={false} 
        open={newPromptTypeName !== undefined} 
        title={`Build new ${newPromptTypeName} prompt`} 
        width={1000} 
        okButtonProps={{loading:isSavingNewPrompt, disabled:isFetchingPromptType || isFetchingPatientEPrescriptionMedications || isFetchingPatientEmnnData || isFetchingPatientFiles || isFetchingPatientJson}}
        cancelButtonProps={{disabled:isSavingNewPrompt}}
        onOk={()=> {
          const requestData = {
            type:newPromptTypeName,
            provider:"GCP",
            model:llmModel.id,
            region:llmRegion,
            temperature:temperature,
            top_p:topP,
            max_output_tokens:maxOutputTokens,
            prompt_template:promptType,
            patient_document_file_ids_to_include:selectedPatientFiles.map(pf => pf.id)
          };
          setIsSavingNewPrompt(true);
          DvAxiosRequestEx({
            method:"POST",
            url:`/ehrAdmin/patients/${patientId}/ai-chats`,
            data:requestData
          }).then((response)=>{
            setIsSavingNewPrompt(false);
            setNewPromptTypeName(undefined);
            //fetchAiChats();
          }, (error)=> {
            setIsSavingNewPrompt(false);
            setNewPromptTypeName(undefined);
            fetchAiChats();
            DvNotification({type:'error', titleString:'Σφάλμα', messageString:'Ένα σφάλμα συνέβει ή η απόκριση καθυστερεί υπερβολικά. Δοκιμάστε να επισκεφθείτε αυτή τη σελίδα σε μερικά λεπτά.'})
          })
        }}
        onCancel={()=>setNewPromptTypeName(undefined)}>
          <Spin spinning={isSavingNewPrompt}>
            <Form layout='vertical'>
              <Form.Item label='Prompt template'>
                <Spin spinning={isFetchingPromptType}>
                  <Input.TextArea value={promptType} onChange={(e)=>setPromptType(e.target.value)} rows={5}/>
                </Spin>
              </Form.Item>

              <div style={{display:'flex', flexDirection:'row', width:'100%', gap:10}}>
                <Form.Item label={<span>Patient data (readonly JSON) <Switch checked={selectedPatientJsonMode === 'json'} checkedChildren='JSON' unCheckedChildren='RAW' onChange={(isJson)=>setSelectedPatientJsonMode(isJson ? 'json' : 'raw')} /> </span>} style={{flex:2}}>
                  <Spin spinning={isFetchingPatientJson}>
                    {selectedPatientJsonMode === 'json' ? <div style={{maxHeight:200, overflow:'auto'}}><ReactJson displayDataTypes={false} enableClipboard={false} src={patientJson} /></div> :<Input.TextArea readOnly value={patientJson ? JSON.stringify(patientJson, null, 5) : ''} rows={10} style={{overflow:'auto', whiteSpace:'pre'}}/>}
                  </Spin>
                </Form.Item>

                <Form.Item label={'Patient files (currently selected: ' + (selectedPatientFiles ? selectedPatientFiles.length : 0) + ')'} help='(only pdf files are currently selectable)' style={{flex:1}}>
                  <Spin spinning={isFetchingPatientFiles}>
                      <Checkbox.Group value={selectedPatientFiles} onChange={(selected)=>setSelectedPatientFiles(selected)} style={{height:200, overflowY:'auto'}}>
                        <Space direction='vertical'>
                          {patientFiles && patientFiles.map((pf,index)=><Checkbox key={index} value={pf} disabled={pf.file_extension !== "pdf" && pf.file_extension !== "PDF"}>{pf.file_name}</Checkbox>)}
                        </Space>
                      </Checkbox.Group>
                  </Spin>
                </Form.Item>
              </div>

              <div style={{display:'flex', flexDirection:'row', width:'100%', gap:10}}>
                <Form.Item label={<span>Eprescription medications (readonly) <Switch checked={selectedEPrescriptionMedicationsMode === 'json'} checkedChildren='JSON' unCheckedChildren='RAW' onChange={(isJson)=>setSelectedEPrescriptionMedicationsMode(isJson ? 'json' : 'raw')} /> </span>} style={{flex:1}}>
                  <Spin spinning={isFetchingPatientEPrescriptionMedications}>
                    {selectedEPrescriptionMedicationsMode === 'json' ? <div style={{maxHeight:100, overflow:'auto'}}><ReactJson displayDataTypes={false} enableClipboard={false} src={patientEPrescriptionMedications} /></div> :<Input.TextArea readOnly value={patientEPrescriptionMedications ? JSON.stringify(patientEPrescriptionMedications, null, 5) : ''} rows={5} style={{overflow:'auto', whiteSpace:'pre'}}/>}
                  </Spin>
                </Form.Item>

                <Form.Item label={<span>EMNN data (readonly) <Switch checked={selectedPatientEmnnDataMode === 'json'} checkedChildren='JSON' unCheckedChildren='RAW' onChange={(isJson)=>setSelectedPatientEmnnDataMode(isJson ? 'json' : 'raw')} /> </span>} style={{flex:1}}>
                  <Spin spinning={isFetchingPatientEmnnData}>
                    {selectedPatientEmnnDataMode === 'json' ? <div style={{maxHeight:100, overflow:'auto'}}><ReactJson displayDataTypes={false} enableClipboard={false} src={patientEmnnData ? patientEmnnData : {}} /></div> :<Input.TextArea readOnly value={patientEmnnData ? JSON.stringify(patientEmnnData, null, 5) : ''} rows={5} style={{overflow:'auto', whiteSpace:'pre'}}/>}
                  </Spin>
                </Form.Item>
              </div>
              
              

              <Divider>LLM parameters</Divider>
              <div style={{display:'flex', flexDirection:'row', width:'100%', gap:10}}>
              
                <Form.Item label="Model" style={{flex:1}}>
                  <Select value={llmModel?.id} onChange={(newModelId)=>{
                    const newModel =availableModels.find(m => m.id === newModelId);
                    setLlmModel(newModel);
                    setMaxOutputTokens(newModel.maxOutputTokens);
                    }}>
                    {availableModels.map(m => <Select.Option key={m.id} value={m.id}>{m.id}</Select.Option>)}
                  </Select>
                </Form.Item>
                <Form.Item label="Region" style={{flex:1}}>
                  <Select value={llmRegion} onChange={(newRegion)=>setLlmRegion(newRegion)}>
                    {availableRegions.map(r => <Select.Option key={r} value={r}>{r}</Select.Option>)}
                  </Select>
                </Form.Item>
                <Form.Item style={{flex:1}} label={<span>Temperature: {temperature} <Tooltip title={<div>Temperature controls the randomness in token selection. A lower temperature is good when you expect a true or correct response. A temperature of 0 means that the highest probability token is usually selected. A higher temperature can lead to diverse or unexpected results. Some models have a higher temperature max to encourage more random responses. The selected model gemini-2.5-flash has a temperature range of 0– 2 and a default of 1</div>}><InfoCircleOutlined /></Tooltip></span>}>
                  <Slider min={0} max={2} value={temperature} step={0.1} onChange={(e)=>setTemperature(e)}/>
                </Form.Item>
                <Form.Item style={{flex:1}} label={<span>Top P: {topP} <Tooltip title={<div>Top-P changes how the model selects tokens for output. Tokens are selected from most probable to least until the sum of their probabilities equals the top-P value. For example, if tokens A, B and C have a probability of .3, .2 and .1 and the Top-P value is .5, then the model will select either A or B as the next token (using temperature). For the least variable results, set Top-P to 0.</div>}><InfoCircleOutlined /></Tooltip></span>}>
                  <Slider min={0} max={1} value={topP} step={0.1} onChange={(e)=>setTopP(e)}/>
                </Form.Item>
                <Form.Item style={{flex:1}} label={'Max output tokens: ' + maxOutputTokens}>
                  <Slider min={0} max={llmModel?.maxOutputTokens ?? 100} value={maxOutputTokens} step={10} onChange={(e)=>setMaxOutputTokens(e)}/>
                </Form.Item>
              </div>
              
            </Form>
          </Spin>
      </Modal>

      <Modal 
        open={selectedAiChat} title={'LLM interaction for ' + selectedAiChat?.prompt_type} 
        closable={true} 
        footer={[
          <Button key='close' type='default' disabled={isSavingNewPrompt} onClick={()=>setSelectedAiChat(undefined)}>Close</Button>,
          <Popconfirm title='Are you sure?' onConfirm={()=>{
            setIsSavingNewPrompt(true);
            DvAxiosRequestEx({
              method:"DELETE",
              url:`/ehrAdmin/patients/${patientId}/ai-chats/${selectedAiChat?.id}`,
            }).then((response)=>{
              setIsSavingNewPrompt(false);
              setNewPromptTypeName(undefined);
              setSelectedAiChat(undefined);
              fetchAiChats();
            }, ()=> {
              setIsSavingNewPrompt(false);
            })
            
          }}><Button key='delete' type='primary' danger loading={isSavingNewPrompt}>Delete</Button></Popconfirm>,
        ]} 
        width={1000}
        onCancel={()=>setSelectedAiChat(undefined)}>
        <Form layout='vertical'>
          <div style={{display:'flex', flexDirection:'row', width:'100%', gap:10}}>
            <Form.Item label='Date (duration)' style={{flex:1}}>
              <Input readOnly value={selectedAiChat? getCreatedDateWithDuration(selectedAiChat) : ''}/>
            </Form.Item>
            <Form.Item label='User' style={{flex:1}}>
              <Input readOnly value={selectedAiChat? selectedAiChat.last_update_user.last_name + ' ' + selectedAiChat.last_update_user.first_name : ''}/>
            </Form.Item>
            <Form.Item label='Prompt type' style={{flex:1}}>
              <Input readOnly value={selectedAiChat?.prompt_type}/>
            </Form.Item>
            
          </div>
          
          <Form.Item label='Prompt' style={{flex:1}}>
              <Input.TextArea readOnly value={selectedAiChat?.raw_prompt} rows={5}/>
          </Form.Item>

          <Form.Item label={<span>LLM configuration <Switch checked={selectedAiChatLlmConfigurationMode === 'json'} checkedChildren='JSON' unCheckedChildren='RAW' onChange={(isJson)=>setSelectedAiChatLlmConfigurationMode(isJson ? 'json' : 'raw')} /> </span>} style={{flex:1}}>
              {selectedAiChatLlmConfigurationMode === 'json' ? <div style={{maxHeight:200, overflow:'auto'}}><ReactJson displayDataTypes={false} enableClipboard={false} src={selectedAiChat?.llm_configuration} /></div> :<Input.TextArea readOnly value={selectedAiChat ? JSON.stringify(selectedAiChat.llm_configuration, null, 5) : ''} rows={5}/>}
          </Form.Item>

          <Spin spinning={selectedAiChat?.processing_status !== 'completed'}>
            <Form.Item label={<span>Response <Switch checked={selectedAiChatResponseMarkdownMode === 'markdown'} checkedChildren='markdown' unCheckedChildren='raw' onChange={(isMarkdown)=>setSelectedAiChatResponseMarkdownMode(isMarkdown ? 'markdown' : 'raw')} /> </span>} style={{flex:1}}>
                {selectedAiChatResponseMarkdownMode === 'markdown' ? <div style={{maxHeight:200, overflow:'auto'}}><MarkdownStyle><ReactMarkdown children={selectedAiChat?.response} remarkPlugins={[remarkGfm]} /></MarkdownStyle></div> :<Input.TextArea readOnly value={selectedAiChat?.response} rows={5}/>}
            </Form.Item>
          </Spin>

          <Form.Item label='Error' style={{flex:1}}>
              <Input.TextArea readOnly value={selectedAiChat?.error} rows={5}/>
          </Form.Item>
          
        </Form>
      </Modal>
    </>
  );
}

const connecteAiClinician = connect((state, props)=> {
  return {
    currentUser:state.Auth.get('currentUser'),
    webSocketConnection:state.Auth.get('webSocketConnection')
  }
}, {})(AiClinician);

export { connecteAiClinician as default };
